import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card } from 'react-bootstrap'



function Eroor400() {

    return (
        <>
            <div className="row justify-content-center mt-5 align-items-center error-page">
                <div className="col-md-6">
                    <div className="form-input-content text-center">
                        <div className="mb-5">
                            <Link className="btn btn-primary" to={'./'}>Back to Home</Link>
                        </div>
                        <h1 className="error-text font-weight-bold">400</h1>
                        <h4 className="mt-4"><i className="fa fa-thumbs-down text-danger"></i> Bad Request</h4>
                        <p>Your Request resulted in an error</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Eroor400;